import { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Chat } from '@/components/ui/chat';
import { ChatUser } from '@/components/ui/chat-avatar';
import { ChatHeader } from '@/components/ui/chat-header';
import { ChatInput } from '@/components/ui/chat-input';
import { ChatMessage } from '@/components/ui/chat-message';
import type { IChatContext } from '@/hooks/use-chat';
export interface ChatProps {
  onSendMessage: (message: string) => void;
  onOpenFeedback: (messageId: string) => void;
  status: 'online' | 'offline';
  name?: string;
}
const Component = forwardRef<IChatContext, ChatProps>(
  ({ onSendMessage, onOpenFeedback, status, name = 'Faktion' }, ref) => {
    const { t } = useTranslation();
    const [value] = useState('');

    return (
      <Chat
        ref={ref}
        className='h-[70vh]'>
        <Chat.Header>
          {name}
          <ChatHeader.Avatar
            user={ChatUser.USER}
            size={'md'}
          />
          <ChatHeader.Status
            status={status}
            size={'sm'}>
            {status}
          </ChatHeader.Status>
        </Chat.Header>
        <Chat.Body>
          {({ messages }) => (
            <div className='flex flex-col gap-2'>
              {messages.map((message) => {
                const user = message.avatar?.user;
                const side = user === ChatUser.USER ? 'right' : 'left';
                return (
                  <ChatMessage
                    key={message.id}
                    side={side}
                    variant={user === ChatUser.USER ? 'default' : 'slot'}>
                    {message.content}
                    {message.avatar && (
                      <ChatMessage.Avatar
                        size={message.avatar.size}
                        user={message.avatar.user}
                      />
                    )}
                    <ChatMessage.Timestamp
                      date={message.timestamp}
                      side={side}
                    />
                    {user === ChatUser.BOT && (
                      <ChatMessage.Metadata
                        side={side}
                        onClick={() => {
                          onOpenFeedback(message.id);
                        }}>
                        {t('blocks.chat.giveFeedback')}
                      </ChatMessage.Metadata>
                    )}
                  </ChatMessage>
                );
              })}
            </div>
          )}
        </Chat.Body>

        <Chat.Footer className='m-1 flex flex-col gap-2'>
          <ChatInput
            value={value}
            onChange={onSendMessage}
            maxHeight={200}></ChatInput>
        </Chat.Footer>
      </Chat>
    );
  }
);
Component.displayName = 'Chat';
export { Component as Chat };
